module.exports = __webpack_public_path__ + "pc/img/main_work_img5.48ab5ca0.jpg";